module.exports = __webpack_public_path__ + "static/claude_2-c5d9b09c112ef7e31eae80ed6e32be7a.png";